module.exports = __webpack_public_path__ + "img/logo-web-transparent-white.ac8d30ca.png";